import useI18n from '@i18n';

import styles from './styles.module.scss';
import { IOfferCardProps } from '../../add/interfaces';

const OfferCard: React.FC<IOfferCardProps> = ({ offer }) => {
    const { t: tCommon } = useI18n('Common');
    const { t } = useI18n('Placements');

    return (
        <div className={styles.offerCard}>
            <img alt="logo" src={offer?.image} className="mb-1 sm:mb-4" />
            <div className="flex justify-between">
                <div>
                    <p className="font-normal text-blueGray-300 text-[12px] sm:text-[14px]">
                        {tCommon('Rate')}
                    </p>
                    <p className="font-medium text-blueGray-600 text-[14px]">
                        {tCommon('up to')} {offer?.webmasterMaxRate}
                        {offer?.webmasterMaxRateSymbol}
                    </p>
                </div>
                <div>
                    <p className="font-normal text-blueGray-300 text-[12px] sm:text-[14px]">
                        {t('% confirmation')}
                    </p>
                    <p className="font-medium text-blueGray-600 text-[14px]">{offer?.confirm}%</p>
                </div>
            </div>
        </div>
    );
};

export default OfferCard;
